import * as React from "react";
import { ComponentType, PropsWithChildren, useContext, useEffect, useState } from "react";
import { GapFillStatusEnum } from "..";
import { ProjectService } from "@app/projects";
import { FeatureFlagContext, Features } from "@app/feature-flags";

export interface GapFillStatusDescriptionProps {
    gapFillStatusDescriptionMap: GapFillStatusDescriptionMap;
}

export type GapFillStatusDescriptionMap = {
    [key in GapFillStatusEnum]: string;
}

const gapFillStatusEmptyDescriptions: GapFillStatusDescriptionMap = {
    [GapFillStatusEnum.gapFilled]: '---',
    [GapFillStatusEnum.none]: '---',
    [GapFillStatusEnum.researching]: '---',
    [GapFillStatusEnum.contractingGapClosure]: '---',
    [GapFillStatusEnum.contractingExceptionEligible]: '---',
    [GapFillStatusEnum.exceptionRequired]: '---',
    [GapFillStatusEnum.rppoWaiverRequired]: '---',
    [GapFillStatusEnum.availableEntitiesWillNotContract]: '---',
}

const useGapFillStatusDescriptions = (): GapFillStatusDescriptionMap => {
    const featureFlags = useContext(FeatureFlagContext);
    const [gapFillStatusDescriptions, setGapFillStatusDescriptions] = useState<GapFillStatusDescriptionMap>(gapFillStatusEmptyDescriptions);

    useEffect(() => {
        const getGapFillStatusDescriptions = async () => {
            const descriptionMap: GapFillStatusDescriptionMap = {...gapFillStatusEmptyDescriptions};
            if (!featureFlags.enabledFeatureFlags.has(Features.GAP_FILL_STATUS)) {
                setGapFillStatusDescriptions(descriptionMap);
                return;
            }
            const projectService = new ProjectService();
            const descriptions = await projectService.getGapFillStatusDescriptions();
            descriptions[GapFillStatusEnum.none] = '---';
            setGapFillStatusDescriptions(descriptions);
        }
        getGapFillStatusDescriptions();
    }, [featureFlags.enabledFeatureFlags]);

    return gapFillStatusDescriptions;
}

export default useGapFillStatusDescriptions;

export function withGapFillStatusDescriptions<T>(Component: ComponentType<PropsWithChildren<T & GapFillStatusDescriptionProps>>): ComponentType<PropsWithChildren<T>> {
    return function WrappedComponent(props) {
        const descriptions = useGapFillStatusDescriptions();
        return <Component {...props} {...{['gapFillStatusDescriptionMap']: descriptions}} />;
    }
}